var mountElement = document.querySelector('#size-calculator-app');
var app = new Vue({
  el: '#size-calculator-app',
  data() {
    return {
      availableSizes: mountElement.getAttribute('size-options').split('|'),
      optionName: mountElement.getAttribute('option-name'),
      showingResults: false,

      unit: 'inches',
      form: {},
      title: 'Size calculator',
      intro: 'Use this size calculator to discover the perfect pump for you. Learn how to correctly measure yourself',
      recommendation: {},
      selectedSize: null,
      showingSizeGuide: false,
    }
  },
  computed: {
    isFormValid() {
      return (this.form.length && this.form.length > 0) && (this.form.girth && this.form.girth > 0);
    },
    matchedSizes() {
      if (!this.form.length && !this.form.girth) {
        return this.availableSizes;
      }

      const lengthValue = this.unit === 'centimeters' ? parseFloat(this.form.length / 2.5) : parseFloat(this.form.length);
      const girthValue = this.unit === 'centimeters' ? parseFloat(this.form.girth / 2.5) : parseFloat(this.form.girth);

      return this.availableSizes.filter((size) => {
        const sizeValue = parseFloat(size.replace(/\D/g, ''));

        if (girthValue <= 6 && lengthValue <= 5) {
          return [5].includes(sizeValue);
        }
        if (girthValue <= 6 && lengthValue <= 5) {
          return [5].includes(sizeValue);
        }
        else if (girthValue <= 6 && lengthValue <= 6) {
          return [5,7].includes(sizeValue);
        }
        else if (girthValue <= 6 && lengthValue <= 7) {
          return [7].includes(sizeValue);
        }
        else if (girthValue <= 6 && lengthValue <= 8) {
          return [7,9].includes(sizeValue);
        }
        else if (girthValue <= 6 && lengthValue <= 9.5) {
          return [9].includes(sizeValue);
        }
        else if (girthValue <= 6.5 && lengthValue <= 7) {
          return [7].includes(sizeValue);
        }
        else if (girthValue <= 6.5 && lengthValue <= 8) {
          return [7,9].includes(sizeValue);
        }
        else if (girthValue <= 6.5 && lengthValue <= 9.5) {
          return [9].includes(sizeValue);
        }
        else if (girthValue <= 7 && lengthValue <= 7.5) {
          return [7,9].includes(sizeValue);
        }
        else if (girthValue <= 7 && lengthValue <= 9.5) {
          return [9].includes(sizeValue);
        }
        else if (girthValue <= 7.6 && lengthValue <= 7.5) {
          return [7,9].includes(sizeValue);
        }
        else if (girthValue <= 7.6 && lengthValue <= 9.5) {
          return [9].includes(sizeValue);
        }
        else {
          return false;
        }
      }).sort();
    }
  },
  methods: {
    getResults() {
      this.setRecommendation();
      this.showingResults = true;
    },
    setRecommendation() {
      const lengthValue = this.unit === 'centimeters' ? parseFloat(this.form.length / 2.5) : parseFloat(this.form.length);
      const girthValue = this.unit === 'centimeters' ? parseFloat(this.form.girth / 2.5) : parseFloat(this.form.girth);

      const recommendedSize = () => {
        switch (true) {
          case (girthValue <= 6 && lengthValue <= 5):
          case (girthValue <= 6 && lengthValue <= 5.5):
            return [5];
          case (girthValue <= 6 && lengthValue <= 6):
          case (girthValue <= 6 && lengthValue <= 7):
          case (girthValue <= 6 && lengthValue <= 7.5):
          case (girthValue <= 6.5 && lengthValue <= 7):
          case (girthValue <= 6.5 && lengthValue <= 7.5):
          case (girthValue <= 7 && lengthValue <= 7):
            return [7];
          case (girthValue <= 6 && lengthValue <= 8):
          case (girthValue <= 6 && lengthValue <= 9.5):
          case (girthValue <= 6.5 && lengthValue <= 8):
          case (girthValue <= 6.5 && lengthValue <= 9.5):
          case (girthValue <= 7 && lengthValue <= 7.5):
          case (girthValue <= 7 && lengthValue <= 8):
          case (girthValue <= 7 && lengthValue <= 9.5):
            return [9];
          default:
            return [];
        }
      }

      this.recommendation = this.availableSizes.find((size) => recommendedSize().includes(parseFloat(size.replace(/\D/g, ''))));
    },
    setUnit(unit) {
      this.unit = unit;
    },
    setSize(size) {
      this.selectedSize = parseInt(size.replace(/\D/g, ''), 10);

      const input = document.querySelector(`[name="${this.optionName}"][value="${size}"]`);
      input.click();
    },
    restart() {
      this.form = {};
      this.showingResults = false;
    },
    complete() {
      this.form = {};
      this.showingResults = false;
      document.querySelector('#ModalClose-sizeCalculator').click();
    },
    toggleSizeGuide() {
      this.showingSizeGuide = !this.showingSizeGuide;
    },
    hideSizeGuide() {
      this.showingSizeGuide = false;
    }
  },
  mounted() {
    document.body.addEventListener('modalClosed', this.hideSizeGuide);
  },
  unmounted() {
    document.body.removeEventListener('modalClosed', this.hideSizeGuide);
  },
  delimiters: ['${', '}'],
})